import { ICharacteristic, IFrontVariation } from 'models/product'
import { getCharacteristicValue } from '../../ProductForm/utils/variationAxes'

export interface IPreviewAxis {
  name: string
  values: string[]
}

// Оси вариаций со всеми значениями, как в блоке «Параметры» на сайте.
// Значение самого товара — в его характеристиках, а не в строках вариаций
export const getPreviewAxes = (
  variations: IFrontVariation[],
  characteristics: ICharacteristic[]
): IPreviewAxis[] => {
  const axes = new Map<string, string[]>()

  const add = (name?: string, value?: string) => {
    const trimmed = value?.trim()
    if (!name || !trimmed) return
    const values = axes.get(name) ?? []
    if (!values.includes(trimmed)) values.push(trimmed)
    axes.set(name, values)
  }

  for (const row of variations) {
    add(row.firstCharacteristicName, row.firstCharacteristicValue)
    add(row.secondCharacteristicName, row.secondCharacteristicValue)
  }

  for (const name of Array.from(axes.keys())) {
    add(name, getCharacteristicValue(characteristics, name))
  }

  return Array.from(axes, ([name, values]) => ({ name, values }))
}
